import type { AppConfig } from '@/config/AppConfig';
import { isE2ETestMode } from './utils/e2e';

const onRedirectCallback = (appState?: { returnTo?: string }) => {
  if (appState?.returnTo) {
    const nextUrl = new URL(appState.returnTo, window.location.origin);
    // Only redirect if it's the same origin
    if (nextUrl.origin === window.location.origin) {
      window.location.replace(nextUrl.toString());
    }
  }
};

// Function to create Auth0 config from AppConfig
export const createAuth0Config = (appConfig: AppConfig) => {
  return {
    domain: appConfig.auth0Domain,
    clientId: appConfig.auth0ClientId,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/login`,
      audience: appConfig.auth0Audience,
    },
    onRedirectCallback,
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    sessionCheckExpiryDays: 7,
  };
};

// Validate required Auth0 configuration
export const validateAuth0Config = (config: AppConfig): boolean => {
  // Skip validation in demo/E2E mode (no auth required)
  if (isE2ETestMode()) {
    return true;
  }

  const hasRequiredFields =
    config.auth0Domain && config.auth0ClientId && config.auth0Audience;

  if (!hasRequiredFields) {
    console.error('Missing required Auth0 configuration in AppConfig:', {
      hasDomain: !!config.auth0Domain,
      hasClientId: !!config.auth0ClientId,
      hasAudience: !!config.auth0Audience,
    });
    return false;
  }

  return true;
};
